import { render, staticRenderFns } from "./AnyFAQMentee.vue?vue&type=template&id=62d5023f&scoped=true"
import script from "./AnyFAQMentee.vue?vue&type=script&lang=js"
export * from "./AnyFAQMentee.vue?vue&type=script&lang=js"
import style0 from "./AnyFAQMentee.vue?vue&type=style&index=0&id=62d5023f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d5023f",
  null
  
)

export default component.exports